import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import ConsoleLogger from "../Utils/ConsoleLogger";
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';



let config = require('../Config/appConfig.json');
let api_credentials_url = config.GET_API_CREDENTIALS;
const context = "Footer.js";

@inject("appStore")
@observer
class Footer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentWillMount = () => {

    }




    componentDidMount = () => {
        //console.log("PROPS", this.props);
    }
    render() {

        return (
            <div>
                <footer className="footer bg-light section-pattern footer-bg" data-bg-img="assets/img/section-pattern/footer-pattern.png">
                    <div className="footer-bottom">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                <div className="copyright-text text-center"> <span><a href="https://www.hexaride.com/">HexaRide Technologies Pvt. Ltd.</a> &copy; Copyright 2019.All rights reserved.</span> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>

            </div>
        );
    }
}

export default withRouter(Footer);


// WEBPACK FOOTER //
// ./src/Pages/Footer.js